import AsyncComponent from '../../component/asynccomponent/AsyncComponent'
import { RolesEnum, CompanyTypesEnum } from '../../utils/Enums';

const company = AsyncComponent(() =>
  import('../../../pages/company/CompanyIndex')
)

const companies = AsyncComponent(() =>
  import('../../../pages/company/CompaniesGrid')
)

export default [
  {
    path: '/company',
    component: company,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.Manager],
    companyTypes: [CompanyTypesEnum.Tranpo]
  },
  {
    path: '/company/:id',
    component: company,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.Manager, RolesEnum.Operator],
    companyTypes: [CompanyTypesEnum.Tranpo, CompanyTypesEnum.Contractor]
  },
  {
    path: '/company/profile/:id',
    component: company,
    isAuthenticated: true,
    roles: [RolesEnum.Manager],
    companyTypes: [CompanyTypesEnum.Contractor, CompanyTypesEnum.Hired]
  },
  {
    path: '/companies',
    component: companies,
    isAuthenticated: true,
    roles: [RolesEnum.BackOffice, RolesEnum.Manager, RolesEnum.Operator],
    companyTypes: [CompanyTypesEnum.Tranpo, CompanyTypesEnum.Contractor]
  }
]



// WEBPACK FOOTER //
// ./src/shared/infra/routes/CompanyRoutes.js